<template>
  <TitleWrapper
    :filter-option="true"
    title="STUDENTS_PERIOD_ATTENDANCE"
    tooltip-title="STUDENTS_PERIOD_ATTANDANCE_RECORDS"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @cancel="cancelHanlder"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper layout-mode="true">
        <UiMultiSelect
          v-if="!isGuardianOrStudent"
          v-model.trim="filtersPayload.student_user_id"
          title="STUDENTS"
          :options="studentList"
          reduce="id"
          label="full_name"
          class="flex-1 mb-5 sm:mb-0"
          input-color="bg-white"
          :already-selected="selectedStudents"
          :search-through-api="true"
          :filter="STUDENT_ID"
          @search="getStudents"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model="filtersPayload.status"
          title="STATUS"
          :options="ATTENDANCE_STATUSES"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.STATUS"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model.trim="filtersPayload.subject_id"
          title="Select Subject"
          :options="subjectList"
          label="title"
          placeholder="Select Subject"
          reduce="id"
          :filter="FILTERS_LIST.SUBJECT"
          :search-through-api="true"
          @emitQuery="updateQuery"
          @search="getSubjectList"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import { getCountFromObject } from '@utils/generalUtil'
import FILTER_KEYS, { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { mapActions, mapState, mapGetters } from 'vuex'
import filterMixins from '@/src/mixins/filter-mixins.js'
import { buildWhereQuery } from '@/src/utils/filters'
import { ATTENDANCE_STATUSES } from '@/src/constants/attandance/attandance-constant.js'
import UiMultiSelect from '@/src/components/UiElements/UiMultiSelect.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiMultiSelect,
    UiSingleSelect,
    TitleWrapper,
    InputFieldWrapper,
  },
  mixins: [filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      STUDENT_ID: {
        option: FILTER_KEYS.IN,
        key: 'student_user_id',
      },
      subjectList: [],
      sectionStudents: [],
      ATTENDANCE_STATUSES,
      FILTER_KEYS,
      studentList: [],
      $where: {},
      selectedStudents: [],
      FILTERS_LIST,
      filtersPayload: {
        status: '',
        subject_id: '',
        student_user_id: [],
        displayedColumns: [],
      },
      filtersCount: 0,
    }
  },

  computed: {
    ...mapState({
      currentSectionScope: (state) => state.layout.currentSectionScope.id,
      currentCampusScope: (state) => state.layout.currentCampusScope.id,
    }),
    ...mapGetters('layout', ['userRole']),

    isGuardianOrStudent() {
      return [TENANT_ROLES.GUARDIAN, TENANT_ROLES.SECTION_STUDENT].includes(this.userRole)
    },
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.getStudents()
        this.clearFilters()
      },
    },

    currentSectionScope: {
      handler() {
        this.getStudents()
        this.clearFilters()
        this.getSubjectList()
      },
    },
  },
  mounted() {
    this.getStudents()
    this.getSubjectList()
    this.updateDisplayedColumnList()
  },
  methods: {
    getStudents(query) {
      if (this.isGuardianOrStudent) return
      let alreadySelectedStudents = []
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'search', query),
        },
      }
      this.getStudentsWithFilters(payload).then((res) => {
        this.studentList = res?.records
        this.studentList?.forEach((record) => {
          if (this.filtersPayload && this.filtersPayload.student_user_id.length) {
            this.filtersPayload.student_user_id.forEach((id) => {
              if (record.id === id) {
                alreadySelectedStudents.push(record)
              }
            })
          }
          this.selectedStudents = alreadySelectedStudents
        })
      })
    },
    getSubjectList(query = '') {
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query),
        },
      }
      this.classSubjects(payload).then((resp) => {
        this.subjectList = resp.data?.records || []
      })
    },
    getFiltersCount() {
      this.getStudents()
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
    ...mapActions('subjects', ['classSubjects']),
    ...mapActions('student', ['getStudentsWithFilters']),
  },
}
</script>
